import create from 'zustand'
import { persist } from 'zustand/middleware'

export const useStore = create(
  persist(
    (set) => ({
      // Editor settings
      settings: {
        credits: 0,
        brushSize: 40,
        hardness: 50,
        opacity: 100,
        preserveAlpha: false,
        blendMode: 'normal',
        maskBlur: 0,
        maskExpand: 0,
        maskFeather: 0,
      },

      // Editor state
      isLoading: false,
      isMaskEnabled: true,
      isErasing: false,
      maskDataURL: null,
      originalImage: null,
      processedImage: null,
      currentHistoryIndex: -1,
      history: [],
      
      // Actions
      updateSettings: (newSettings) => set((state) => ({
        settings: {
          ...state.settings,
          ...newSettings
        }
      })),

      setLoading: (isLoading) => set({ isLoading }),
      
      setMaskEnabled: (isMaskEnabled) => set({ isMaskEnabled }),
      
      setErasing: (isErasing) => set({ isErasing }),
      
      setMaskDataURL: (maskDataURL) => set({ maskDataURL }),
      
      setOriginalImage: (originalImage) => set({ originalImage }),
      
      setProcessedImage: (processedImage) => set({ processedImage }),
      
      addToHistory: (historyItem) => set((state) => {
        const newHistory = [
          ...state.history.slice(0, state.currentHistoryIndex + 1),
          historyItem
        ]
        return {
          history: newHistory,
          currentHistoryIndex: newHistory.length - 1
        }
      }),

      undo: () => set((state) => {
        if (state.currentHistoryIndex <= 0) return state
        return {
          currentHistoryIndex: state.currentHistoryIndex - 1,
          maskDataURL: state.history[state.currentHistoryIndex - 1]
        }
      }),

      redo: () => set((state) => {
        if (state.currentHistoryIndex >= state.history.length - 1) return state
        return {
          currentHistoryIndex: state.currentHistoryIndex + 1,
          maskDataURL: state.history[state.currentHistoryIndex + 1]
        }
      }),

      resetEditor: () => set({
        settings: {
          credits: 0,
          brushSize: 40,
          hardness: 50,
          opacity: 100,
          preserveAlpha: false,
          blendMode: 'normal',
          maskBlur: 0,
          maskExpand: 0,
          maskFeather: 0,
        },
        isLoading: false,
        isMaskEnabled: true,
        isErasing: false,
        maskDataURL: null,
        originalImage: null,
        processedImage: null,
        currentHistoryIndex: -1,
        history: [],
      }),

      // Credit management
      addCredits: (amount) => set((state) => ({
        settings: {
          ...state.settings,
          credits: state.settings.credits + amount
        }
      })),

      removeCredits: (amount) => set((state) => ({
        settings: {
          ...state.settings,
          credits: Math.max(0, state.settings.credits - amount)
        }
      })),

      setCredits: (amount) => set((state) => ({
        settings: {
          ...state.settings,
          credits: amount
        }
      })),
    }),
    {
      name: 'editor-storage',
      getStorage: () => localStorage,
    }
  )
)